import { GlobalState } from '@/scripts/config/globalState'
import type { Activity, Page } from './types'

export function getActivityByItemId(itemId: string): Activity | undefined {
  return GlobalState.activities.find((a) => a.positionId === itemId)
}

export function getActivityByHash(hash: string): Activity | undefined {
  return GlobalState.activities.find((a) => a.linkHash === hash)
}

export function getActivityByPartialHash(hash: string): Activity | undefined {
  return GlobalState.activities.find((a: Activity) => hash.startsWith(a.linkHash))
}

export function getPageByHash(hash: string): Page | undefined {
  return GlobalState.pages.find((p) => p.linkHash === hash)
}
